import Panzoom from '@panzoom/panzoom'
import type { PanzoomObject, PanzoomOptions } from '@panzoom/panzoom'

declare module '#app' {
  interface NuxtApp {
    $panzoom: (el: HTMLElement, options?: PanzoomOptions) => PanzoomObject;
  }
}

export default defineNuxtPlugin((nuxtApp) => {
  // optional programmatic helper
  nuxtApp.provide('panzoom', (el: HTMLElement, options: PanzoomOptions = {}) => Panzoom(el, options))

  // v-panzoom directive (BASIC)
  nuxtApp.vueApp.directive('panzoom', {
    mounted (el, binding) {
      const options: PanzoomOptions = {
        minScale: 1,
        maxScale: 6,
        ...(binding.value || {})
      }
      const pz = Panzoom(el as HTMLElement, options);

      (el as any).__panzoom__ = pz

      // wheel/trackpad zoom (library’s helper)
      const wheelTarget = (el.parentElement ?? el) as HTMLElement
      const wheelHandler = (e: WheelEvent) => {
        e.preventDefault()
        pz.zoomWithWheel(e)
      }
      wheelTarget.addEventListener('wheel', wheelHandler, { passive: false });

      (el as any).__panzoom_cleanup__ = () => {
        wheelTarget.removeEventListener('wheel', wheelHandler as any)
        pz.destroy?.()

        delete (el as any).__panzoom__
      }
    },
    unmounted (el) {
      (el as any).__panzoom_cleanup__?.()

      delete (el as any).__panzoom_cleanup__
    }
  })
})
